import { Credit } from '@/app/credit/entities/credit.entity'

export interface CreditState {
    credits: Credit[]
}

export const state: CreditState = {
    credits: []
}
